// Type
import { FlatNode, TreeNode, ParsedNode, MappedNode } from "./MeFormType";

/**
 * Update ส่วนของ Content (Decision Tree) ของ Form นั้น ๆ
 * @param currentContent - Original/Current Content
 * @param modifier - ส่วน (Section/Node) ที่แก้ไข
 * @returns
 */
export const updateContent = (
  currentContent: string,
  modifier: (parsed: ParsedNode) => void
): string => {
  if (!currentContent) return currentContent;

  try {
    const parsed: ParsedNode = JSON.parse(currentContent);

    modifier(parsed);

    return JSON.stringify(parsed, null, 2);
  } catch (err) {
    console.error("Invalid JSON Content: ", err);

    return currentContent;
  }
};

/**
 * สร้าง JSON Tree Structure จาก Content string
 * @param content - Content string
 * @returns
 */
export const buildTree = (content: string): TreeNode[] => {
  if (!content) return [];

  try {
    const parsed: ParsedNode = JSON.parse(content);
    const nodes = Object.values(parsed);
    const map: MappedNode = {};

    nodes.forEach((node) => {
      map[node.id] = { ...node, children: [] };
    });

    const roots: TreeNode[] = [];

    nodes.forEach((node) => {
      if (node.parent_id === null) {
        roots.push(map[node.id]);
      } else if (map[node.parent_id]) {
        map[node.parent_id].children?.push(map[node.id]);
      }
    });

    return roots;
  } catch (err) {
    console.error("Invalid JSON Content: ", err);

    return [];
  }
};

/**
 * สำหรับ Generate Group Name ของ Decision Tree Form
 * @param nodeId
 * @param parsed
 * @returns
 */
export const generateGroupName = (nodeId: number, parsed: Record<number, FlatNode>): string => {
  const node = parsed[nodeId];
  if (!node) return "";

  if (node.parent_id === null) {
    return node.text || "";
  }

  const pathParts: string[] = [];

  let current: FlatNode | undefined = node;
  while (current) {
    // root ใช้ text, child ใช้ condition
    // if (current.parent_id === null) {
    //   if (current.text) pathParts.unshift(current.text);
    // } else {
    //   if (current.condition) pathParts.unshift(current.condition);
    // }

    // ข้าม root node (parent_id === null) ไม่เอา text มาใส่
    if (current.parent_id !== null) {
      if (current.condition) pathParts.unshift(current.condition);
    }
    current = current.parent_id != null ? parsed[current.parent_id] : undefined;
  }

  return pathParts.join(" - ");
};

/**
 * สำหรับ Generate Group Name ให้ Node ที่ยังไม่มีการตั้งชื่อใด ๆ (สร้าง Node ครั้งแรก)
 * @param node
 * @param parsed
 * @returns
 */
export const assignGroupNameOnce = (node: FlatNode, parsed: ParsedNode) => {
  if (!node.group_name || node.group_name.trim() === "") {
    node.group_name = generateGroupName(node.id, parsed);
  }

  return node;
};

export const preserveGroupNameOnMerge = (existing: FlatNode, incoming: FlatNode): FlatNode => {
  return {
    ...existing,
    ...incoming,
    group_name: existing.group_name || incoming.group_name || "",
  };
};

export const updateGroupNameIfEmptyRecursive = (nodeId: number, parsed: ParsedNode) => {
  const node = parsed[nodeId];
  if (!node) return;

  assignGroupNameOnce(node, parsed);

  Object.values(parsed).forEach((child) => {
    if (child.parent_id === nodeId) {
      updateGroupNameIfEmptyRecursive(child.id, parsed);
    }
  });
};

export const formatCredit = (credit?: string): string => {
  if (!credit) return "";

  return Number(credit).toLocaleString(undefined, { minimumFractionDigits: 2 });
};

export const creditAmount = (balance: string, creditUsed: string): number => {
  return Number(balance) - Number(creditUsed);
};

export const formatDateTimeToISO = (dateStr?: string, timeStr?: string) => {
  if (!dateStr || !timeStr) return "";
  
  try {
    const [dd, mm, beYear] = dateStr.split("/");
    const [hr, min] = timeStr.split(":");

    if (!dd || !mm || !beYear || !hr || !min) return "";

    const yyyy = (parseInt(beYear) - 543).toString();

    return `${yyyy}-${mm}-${dd}T${hr}:${min}+07:00`;
  } catch {
    return "";
  }
};